module.exports = __webpack_public_path__ + "img/cancel.c4a8f17f.png";